import Head from 'next/head'
import React from 'react'

export const GlobalStyle = () => (
  <Head>
    <style key="syd-airport">{`
    @font-face {
      font-family: 'Regola Pro';
      src: url('/static/fonts/RegolaPro-Bold.woff') format('woff');
      font-display: swap;
      font-weight: bold;
    }

    @font-face {
      font-family: 'Manrope';
      src: url('/static/fonts/RegolaPro-Regular.woff') format('woff');
      font-display: swap;
      font-weight: normal;
    }

    * {
      font-family: "Regola Pro" !important;
    }
  `}</style>
  </Head>
)
